import { COLORS } from '../../../config';
import confirmSVG from '../../../assets/svg/button_on-01.svg';
import Icon from '../../../helpers/components/Icon';

const SelectToPrintTypeField = ({ forTable, rowsItem, selectItem, selectedItemsToPrint }) => {
  if (forTable) {
    return (
      <div
        style={{
          ...(true ? { backgroundColor: 'rgb(128 128 128 / 10%)' } : {}),
          width: '18px',
          height: '18px',
          border: '2px solid grey',
          cursor: 'pointer',
        }}
        onClick={() => {
          selectItem({ id: rowsItem.id, barcode: rowsItem.value.barcode });
        }}
      >
        {selectedItemsToPrint?.find((val) => val.id == rowsItem.id) && (
          <Icon color={COLORS.color_hover2} src={confirmSVG} width={'17px'} height={'17px'} />
        )}
      </div>
    );
  }
  return null;
};

export default SelectToPrintTypeField;
